/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Quoclvv1 (quoclvv1@rsupport.com)
 *
 * @description
 *
 * @created at Thu Jul 04 2024
 **/

import dayjs from "dayjs";
import { atom } from "jotai";

type MeetingInformationType = {
	scheduleId?: string;
	conferenceId?: string;
	spaceThemeUrl: string;
	title: string;
	url: string;
	startTime: number;
	endTime: number;
	privateMeeting?: boolean;
	accessCode?: string;
};

type MeetingInfoNotiType = {
	scheduleId?: string;
	scheduleStartTime?: number;
};

export const ScheduleIDAtom = atom<string | null>("");
export const ConferenceIDAtom = atom<string | null>("");
export const GroupIDAtom = atom<string | null>("");
export const RecentGroupAtom = atom<{ label: string; value: string } | null>(null);
export const ConferenceRoomNumberAtom = atom<number>(1);
export const IsConferenceEdittedAtom = atom<boolean>(false);
export const ConferenceSettingTab = atom<string>("participants");
export const TemporateStarttime = atom<dayjs.Dayjs | null>(null);
export const SelectedMeeting = atom<string>("");
export const MeetingStartTime = atom<number | null>(null);
export const IsMeetingOpenFromNoti = atom<boolean>(false);
export const MeetingInformationAtom = atom<Nullable<MeetingInformationType>>(null);
export const MeetingInfoNotiAtom = atom<Nullable<MeetingInfoNotiType>>(null);
